import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Filter } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

const CATEGORIES = [
  { id: "all", label: "All Props" },
  { id: "furniture", label: "Furniture" },
  { id: "decor", label: "Decor" },
  { id: "backdrops", label: "Backdrops" },
  { id: "tabletop", label: "Tabletop" },
  { id: "themed", label: "Themed" },
];

export default function PropsRental() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  const { add } = useCart();

  useEffect(() => {
    api.get("/props", { params: cat !== "all" ? { category: cat } : {} }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div data-testid="props-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-8">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Props Rental</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mb-6 max-w-4xl">
          Curated props for <span className="text-gradient-animate">every shoot.</span>
        </h1>
        <p className="text-lg text-[#52525B] max-w-2xl">
          Furniture, decor, backdrops, themed sets — rent by the day with delivery or pickup.
        </p>
      </section>

      <section className="container mx-auto px-4 pb-24">
        <div className="flex gap-2 overflow-x-auto pb-4 mb-6 border-b border-zinc-200">
          <Filter className="w-5 h-5 text-zinc-500 mt-2 mr-1 shrink-0" />
          {CATEGORIES.map((c) => (
            <button key={c.id} onClick={() => setCat(c.id)} data-testid={`prop-cat-${c.id}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition ${
                cat === c.id ? "bg-[#0A1128] text-white" : "bg-zinc-100 hover:bg-zinc-200"
              }`}>
              {c.label}
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200 border border-zinc-200">
          {items.map((p) => (
            <div key={p.id} data-testid={`prop-card-${p.id}`} className="group bg-white p-4 hover:bg-zinc-50 transition">
              <Link to={`/props/${p.id}`} className="block aspect-square mb-4 overflow-hidden rounded-xl bg-zinc-100">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
              </Link>
              <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1">{p.category}</div>
              <Link to={`/props/${p.id}`} className="font-display font-bold text-lg leading-tight hover:text-[#FF007F] transition">
                {p.name}
              </Link>
              <div className="flex items-center justify-between mt-3">
                <div>
                  <div className="font-display font-black text-lg text-gradient-animate">₹{p.daily_rate.toLocaleString()}<span className="text-xs text-zinc-500 font-medium">/day</span></div>
                  <div className="text-[10px] text-zinc-500">+ ₹{p.deposit} deposit</div>
                </div>
                <button onClick={() => { add(p); toast.success(`${p.name} added to cart`); }} data-testid={`add-cart-${p.id}`}
                  className="w-9 h-9 rounded-full bg-[#0A1128] text-white grid place-items-center hover:bg-gradient-brand transition">
                  <Plus className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
